// Campus photo for /colleges/thomas-jefferson-university: CC BY 4.0, by Jim.henderson, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3APhila_U_2021_(05)_jeh.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/thomas-jefferson-university/; credited under the photo.
const photo = {
    "slug": "thomas-jefferson-university",
    "alt": "The Paul J. Gutman Library among shade trees on the East Falls campus of Thomas Jefferson University in Philadelphia",
    "src": "/colleges/thomas-jefferson-university/campus-1600.webp",
    "srcSmall": "/colleges/thomas-jefferson-university/campus-800.webp",
    "srcMid": "/colleges/thomas-jefferson-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/thomas-jefferson-university/og.jpg",
    "title": "Phila U 2021 (05) jeh",
    "author": "Jim.henderson",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3APhila_U_2021_(05)_jeh.jpg",
    "read": "2026-10-01"
};

export default photo;
